module.exports = __webpack_public_path__ + "static/img/cgal4.cb08e5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal4.png
// module id = BA8D
// module chunks = 1